module.exports = require("!!vue-loader!../../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./ExampleCustomForm.md");


//////////////////
// WEBPACK FOOTER
// ./src/components/Demo/CustomComponent/ExampleCustomForm.md
// module id = +blW
// module chunks = 1